import { render, staticRenderFns } from "./SuccessModal.vue?vue&type=template&id=6013d4e3&"
import script from "./SuccessModal.vue?vue&type=script&lang=ts&"
export * from "./SuccessModal.vue?vue&type=script&lang=ts&"
import style0 from "./SuccessModal.vue?vue&type=style&index=0&id=6013d4e3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports